import { Badge } from '@fluentui/react-components';
import type { BookkeepingStatusCategory } from '../../types';
import i18n from '../../i18n';

type StatusBadgeColor = 'success' | 'brand' | 'warning' | 'subtle';

// Shared mapping for the derived bookkeeping status category (see
// deriveStatusCategory in ../../types). Previously duplicated verbatim in
// ClientsPage and ClientDetailPage, with a third inline copy in DashboardPage.
export function statusBadgeColor(category: BookkeepingStatusCategory): StatusBadgeColor {
  switch (category) {
    case 'completed':
      return 'success';
    case 'in-progress':
      return 'brand';
    case 'waiting':
      return 'warning';
    case 'not-started':
    default:
      return 'subtle';
  }
}

export function statusDisplayName(category: BookkeepingStatusCategory): string {
  switch (category) {
    case 'completed':
      return i18n.t('clientStatus.completed');
    case 'in-progress':
      return i18n.t('clientStatus.inProgress');
    case 'waiting':
      return i18n.t('clientStatus.waiting');
    case 'not-started':
    default:
      return i18n.t('clientStatus.notStarted');
  }
}

export function StatusBadge({ category }: { category: BookkeepingStatusCategory }) {
  return (
    <Badge appearance="filled" color={statusBadgeColor(category)}>
      {statusDisplayName(category)}
    </Badge>
  );
}
